import { forwardRef, type ChangeEventHandler, type FocusEventHandler } from 'react';
import { NumericFormat, PatternFormat, type OnValueChange } from 'react-number-format';

interface InputTypePropTypes {
  name: string;
  id?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  value?: string | number;
  placeholder?: string;
  amount?: boolean;
  format?: string;
  mask?: string;
  suffix?: string;
  inputClassName?: string;
  onValueChange?: OnValueChange;
  type?: 'text' | 'tel' | 'password';
  disabled?: boolean;
  allowEmptyFormatting?: boolean;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
}

type InputRefType = HTMLInputElement;

const InputType = forwardRef<InputRefType, InputTypePropTypes>(
  (
    {
      name,
      id,
      onChange,
      onValueChange,
      value,
      placeholder,
      amount,
      format,
      mask,
      suffix,
      inputClassName,
      allowEmptyFormatting,
      type = 'text',
      disabled,
      onFocus,
      onBlur,
    },
    ref,
  ) => {
    const defaultProps = {
      name: name || id,
      id: name || id,
      placeholder,
      className: inputClassName,
      onChange,
      value,
      type,
      disabled,
      onFocus,
      onBlur,
    };

    const renderTypeInput = () => {
      if (amount) {
        return (
          <NumericFormat
            getInputRef={ref}
            decimalScale={2}
            maxLength={20}
            min={1}
            max={10000000}
            thousandSeparator=" "
            decimalSeparator="."
            fixedDecimalScale
            onValueChange={onValueChange}
            suffix={suffix}
            {...defaultProps}
          />
        );
      }

      if (format) {
        return (
          <PatternFormat
            getInputRef={ref}
            format={format}
            mask={mask}
            allowEmptyFormatting={allowEmptyFormatting}
            {...defaultProps}
          />
        );
      }

      return <input ref={ref} {...defaultProps} />;
    };

    return renderTypeInput();
  },
);

export { InputType };

export type { InputTypePropTypes, InputRefType };
